/* KWD Revamp - subtle scroll reveal for homepage sections.
   Progressive enhancement: transform-only reveal added via .kwd-reveal by THIS script, so
   nothing is ever hidden if JS is off. Failsafe reveals all after 2.5s. Reduced-motion skipped. */
(function () {
  try {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function init() {
      var nodes = document.querySelectorAll('#MainContent > .shopify-section');
      if (!nodes || nodes.length < 2) return;
      var targets = Array.prototype.slice.call(nodes, 1);
      targets.forEach(function (el) { el.classList.add('kwd-reveal'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('kwd-inview'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      targets.forEach(function (el) { io.observe(el); });
      setTimeout(function () { targets.forEach(function (el) { el.classList.add('kwd-inview'); }); }, 2500);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  } catch (err) { /* fail open */ }
})();

/* KWD Revamp - Cart bottom, rebuilt as one deterministic block. */
(function () {
  try {
    if (!/^\/cart(\/|$)/.test(location.pathname)) return;

    var THRESHOLD = 15000;
    var SUBKEY = 'Substitution preference';
    var SUBOPTS = [
      { v: 'Substitutions OK', l: 'Substitutions are OK' },
      { v: 'Call me first', l: 'OK, but call me first' },
      { v: 'Do not substitute', l: 'Please do not substitute' }
    ];
    var SUBDEFAULT = 'Call me first';

    function money(c) { return '$' + (c / 100).toFixed(2); }
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
    function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }); }

    function init() {
      if (document.querySelector('.kwd-zone')) return;
      var form = document.querySelector('#MainContent form.cart') || document.querySelector('#MainContent form[action^="/cart"]');
      if (!form || !form.parentNode) return;

      var zone = document.createElement('div');
      zone.className = 'kwd-zone';
      form.parentNode.insertBefore(zone, form.nextSibling);

      var recsWrap = document.createElement('div');
      recsWrap.className = 'kwd-recs';
      recsWrap.style.display = 'none';
      zone.appendChild(recsWrap);

      var row = document.createElement('div');
      row.className = 'kwd-cta-row';

      var noteCard = document.createElement('div');
      noteCard.className = 'kwd-cbox kwd-note';
      noteCard.innerHTML =
        '<div class="kwd-cbox__h">Have a discount code?</div>' +
        '<div class="kwd-cbox__b">No problem. You will add your code on the next page, at checkout.<br><br>' +
        'One thing to know: a code and free shipping cannot be combined, so if you use a code your order ships at our standard rate.</div>';
      row.appendChild(noteCard);

      var subCard = document.createElement('div');
      subCard.className = 'kwd-cbox kwd-sub';
      var opts = SUBOPTS.map(function (o) {
        return '<label class="kwd-sub__opt"><input type="radio" name="kwd-sub" value="' + o.v + '"><span>' + o.l + '</span></label>';
      }).join('');
      subCard.innerHTML =
        '<div class="kwd-cbox__h">If something is out of stock</div>' +
        '<div class="kwd-sub__note">Sometimes an item sells out everywhere, even at our suppliers. If that happens, how should we handle your order?</div>' +
        '<div class="kwd-sub__opts">' + opts + '</div>' +
        '<div class="kwd-sub__foot">Any bottle we swap in is always equal or greater value. If you ask us not to substitute, we may hold your order until we can reach you.</div>';
      row.appendChild(subCard);
      zone.appendChild(row);

      var co = document.createElement('div');
      co.className = 'kwd-checkout';
      co.innerHTML = '<a class="kwd-co-btn" href="/checkout">Check out</a>';
      zone.appendChild(co);

      try {
        var oldControls = document.querySelector('#MainContent .cart__submit-controls');
        if (oldControls) oldControls.style.display = 'none';
        var oldNote = Array.prototype.slice.call(document.querySelectorAll('#MainContent .cart__footer *'))
          .find(function (e) { return e.children.length === 0 && /free shipping cannot be combined|discount codes and free shipping/i.test(e.textContent); });
        if (oldNote) { var host = oldNote.closest('p, div') || oldNote; host.style.display = 'none'; }
      } catch (e) {}

      var radios = subCard.querySelectorAll('input[name=kwd-sub]');
      radios.forEach(function (r) { r.addEventListener('change', function () { var b = { attributes: {} }; b.attributes[SUBKEY] = r.value; post('/cart/update.js', b); }); });

      /* Repaint hook for anything that changes the total without a reload (the
         gift-card tick box). The $150 threshold and the three panel states live
         in buildBar and nowhere else. */
      window.KWDShipBar = function (total) { buildBar(form, total || 0); };

      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        buildBar(form, cart.total_price || 0);
        var cur = cart.attributes && cart.attributes[SUBKEY];
        var val = cur || SUBDEFAULT;
        radios.forEach(function (r) { if (r.value === val) r.checked = true; });
        if (!cur) { var b = { attributes: {} }; b.attributes[SUBKEY] = SUBDEFAULT; post('/cart/update.js', b); }
        if (cart.items && cart.items.length) {
          var pid = cart.items[0].product_id;
          fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=related')
            .then(function (r) { return r.json(); })
            .then(function (d) { buildRecs(recsWrap, d.products); })
            .catch(function () {});
        }
      }).catch(function () {});
    }

    /* Cheapest paid rate anywhere in a zone that HAS a free tier (Domestic UPS
       Ground, and the West/TX/KY 1-3 bottle rate). Below a gap this size, topping
       the cart up to $150 costs the shopper less than the shipping they would
       otherwise pay — so it stops being an upsell and becomes arithmetic.
       AK/HI/PR have no free tier at all, hence the "lower 48" wording. */
    var SHIP_COST = 2000;
    var CLOSE_AT = THRESHOLD - SHIP_COST;   /* $130.00 */

    function buildBar(form, total) {
      var el = document.querySelector('.kwd-ship');
      if (!el) { el = document.createElement('div'); el.className = 'kwd-ship'; form.insertBefore(el, form.firstChild); }
      var rem = THRESHOLD - total;
      /* Never paint a full bar while the message still asks for money. Math.round
         sends anything from $149.25 up to 100%, so the meter read completely full
         inside a panel saying "Only $0.01 to free shipping". Cap at 99 until the
         threshold is genuinely met. */
      var pct = rem > 0
        ? Math.max(4, Math.min(99, Math.round(total / THRESHOLD * 100)))
        : 100;
      var msg, nudge = '', state = '';

      if (rem <= 0) {
        state = ' kwd-ship--won';
        msg = 'You have unlocked <strong>free shipping</strong>';
      } else if (total >= CLOSE_AT) {
        /* The state that was missing. A cart at $145.05 was abandoned on
           2026-08-05 while being quoted $20 to ship: $4.95 short of free, and
           nothing on the page said so in a way that registered. */
        state = ' kwd-ship--close';
        msg = 'Only <strong>' + money(rem) + '</strong> to free shipping';
        /* The cost-comparison line that used to sit here - "Adding $X costs you
           less than the shipping on this order" - was pulled 2026-08-05 before it
           ever reached a customer. We do not know the shopper's zone at cart time;
           AK/HI/PR have no free tier at ANY total; and a discount code cannot be
           combined with free shipping, which the discount card lower down this
           same page already says. So the sentence is simply false for real
           customers, and blank beats wrong. The amber panel and the bigger number
           carry the urgency on their own. Any replacement wording is a promise to
           a customer, which is the owner's call, not this routine's. */
      } else {
        msg = 'You are <strong>' + money(rem) + '</strong> away from free shipping';
      }

      /* The panel background goes on an INNER wrapper, never on .kwd-ship itself:
         .kwd-ship is the cart form's first child and its box picks up sibling
         layout (it measures ~142px tall around a ~55px meter), so painting it
         directly bleeds the panel up over the "YOUR CART" heading. */
      el.className = 'kwd-ship' + state;
      el.innerHTML = '<div class="kwd-ship__panel">' +
        '<div class="kwd-ship__msg">' + msg + '</div>' +
        '<div class="kwd-ship__track"><div class="kwd-ship__fill" style="width:' + pct + '%"></div></div>' +
        nudge +
        '</div>';
    }

    function buildRecs(wrap, products) {
      if (!products || !products.length) { wrap.style.display = 'none'; return; }
      var cards = products.slice(0, 4).map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        var vid = v ? v.id : '';
        var addBtn = vid ? '<button class="kwd-rec__add" type="button" data-vid="' + vid + '">Add to cart</button>' : '<a class="kwd-rec__add" href="' + p.url + '">View</a>';
        return '<div class="kwd-rec">' +
          '<a class="kwd-rec__img" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="kwd-rec__t" href="' + p.url + '">' + esc(p.title) + '</a>' +
          '<div class="kwd-rec__p">' + money(p.price) + '</div>' + addBtn + '</div>';
      }).join('');
      wrap.innerHTML = '<div class="kwd-recs__h">You may also like</div><div class="kwd-recs__row">' + cards + '</div>';
      wrap.style.display = '';
      wrap.querySelectorAll('button.kwd-rec__add').forEach(function (b) {
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = 'Adding...';
          post('/cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1 }] })
            .then(function () { location.reload(); })
            .catch(function () { b.disabled = false; b.textContent = 'Add to cart'; });
        });
      });
    }

    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  } catch (err) {}
})();

